// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//type
import { testimonialType } from '../api/testimonials/type/testimonialsType';

//mui icons
import StarIcon from '@mui/icons-material/Star';

interface TestimonialCardPrps {
  element: testimonialType
}

const TestimonialCard = ({element}: TestimonialCardPrps) => {
  return (
    <div className="max-w-[550px] p-5 mb-5">
      <div className="flex justify-center items-center text-secondaryColor mb-3">
        {[...Array(element.stars)].map((_, index) => (
          <StarIcon key={index} />
        ))}
      </div>
      <p className="text-xl">{element.text}</p>
      <h4 >{element.user_name}</h4>
      <span>{`${element.city} - ${element.country}`}</span>
    </div>
  )
}

export default TestimonialCard
